type WithOptionalError = { errors?: { [idx: string]: string } };

export class ResponseWithStatus<T> {
  public readonly authError: boolean;
  public readonly error: boolean;
  public readonly ok: boolean;
  public readonly result: (T & WithOptionalError) | null;
  public readonly status: number;
  public readonly originalBody: string | null;
  private constructor(
    status: number,
    result: (T & WithOptionalError) | null,
    originalBody: string | null = ''
  ) {
    this.authError = status === 401 || status === 403;
    this.error = this.authError || status >= 400;
    this.ok = !this.error;
    this.result = result;
    this.status = status;
    this.originalBody = originalBody;
  }

  public static Create<T>(status: number, body: string) {
    let result: (T & WithOptionalError) | null = null;
    let originalBody: string | null = null;
    try {
      result = JSON.parse(body);
    } catch (_) {
      result = null;
      originalBody = body;
    }
    return new ResponseWithStatus<T>(status, result, originalBody);
  }

  public static CreateGetCookiesToSet<T>(response: Response) {
    let result: (T & WithOptionalError) | null = null;
    const cookieStrings: string = response.headers?.get('set-cookie') || '';
    const cookies: Record<string, string> = {};
    try {
      cookieStrings.split(';').forEach((cookie) => {
        const cookieParts = cookie.trim().split('=');
        if (cookieParts[0]) {
          cookies[cookieParts[0]] = cookieParts[1];
        }
      });
    } catch (_) {
      result = null;
    }

    return new ResponseWithStatus<T>(
      response.status,
      // @ts-ignore
      { cookies },
      cookieStrings
    );
  }

  public static CreateFromResult<T>(
    result: T & WithOptionalError,
    status = 200
  ) {
    return new ResponseWithStatus<T>(status, result);
  }
}
